import * as React from 'react';
import { customEditableFieldFactory } from 'common/components/core/common/CustomEditableField';
import EditableChipsList from 'common/components/core/chips/EditableChipsList';
import ChipsList from 'common/components/core/chips/ChipsList';
const EditableChipsListFieldComponent = customEditableFieldFactory({
    ActiveFieldComponent: EditableChipsList,
    InactiveFieldComponent: ChipsList
});

class EditableChipsListField extends React.Component {
    getSelectMenuRef = ref => {
        this.selectMenuListRef = ref;
    };
    getOutsideClickContainer = () => {
        return this.selectMenuListRef;
    };
    noOptionsMessage = () => {
        return null;
    };
    render() {
        return (
            <EditableChipsListFieldComponent
                {...this.props}
                noOptionsMessage={this.noOptionsMessage}
                portal
                getSelectMenuRef={this.getSelectMenuRef}
                getExtraContainer={this.getOutsideClickContainer}
            />
        );
    }
}
export { EditableChipsListField };
export default EditableChipsListField;
